module.exports = "<div class=\"sign-in-page h-full\">\n\n</div>\n\n\n\n"